import styled from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FirstColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ColumnWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.col-2 {
    flex: 1;
  } /* Description */
  &.col-3 {
    flex: 1;
  } /* Status */
  &.col-4 {
    flex: 1;
  } /* Date */
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const InlineTagWrapper = styled.div`
  display: inline-flex;
  max-width: 100%;
`;
